import React from 'react';
import * as styles from './ServicesBlocks.module.scss';
import classNames from 'classnames';

import arrowRight from '@images/icons/arrow-right.svg';
import { Link } from 'gatsby';
import { ServicesBlocksProps } from './ServicesBlocksProps';

export const ServicesBlocks: React.FC<ServicesBlocksProps> = ({
	blocksData,
	isAreasOfExpertise = false,
}) => {
	return (
		<div className={classNames('row', styles.areaGrid)}>
			{blocksData.map((item, index) => (
				<Link
					to={item.url}
					key={`${item.title}${index}`}
					className={classNames(
						styles.areaCard,
						'col-12 col-md-6 col-xl-3 p-4 d-flex flex-column justify-content-between'
					)}
				>
					<div className={styles.content}>
						<img src={item.icon} />
						<div
							className={classNames(styles.title, 'my-3 font-size-22 font-600')}
						>
							{item.title}
						</div>
						{item.content}
					</div>
					{(isAreasOfExpertise ? blocksData.length - 1 : blocksData.length) >
						index && (
						<div className={classNames(styles.readMore, 'mt-3')}>
							Read more <img src={arrowRight} />
						</div>
					)}
				</Link>
			))}
		</div>
	);
};
